var modal = document.getElementById("myModal");
var btn = document.getElementById("myBtn");
var btnFloating = document.getElementById("myBtnFloating");
var span = document.getElementsByClassName("close")[0];

btn.onclick = function() {
    modal.style.display = "block";
}
btnFloating.onclick = function() {
    modal.style.display = "block";
}
span.onclick = function() {
    modal.style.display = "none";
}
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}

// モーダルを開く処理
document.getElementById('myBtn').addEventListener('click', function() {
  document.getElementById('myModal').classList.add('open');
});
document.getElementById('myBtnFloating').addEventListener('click', function() {
  document.getElementById('myModal').classList.add('open');
});

// モーダルを閉じる処理
document.querySelector('.close').addEventListener('click', function() {
  document.getElementById('myModal').classList.remove('open');
});

// セレクトボックスのオンオフ
document.addEventListener('DOMContentLoaded', function() {
    var checkbox = document.getElementById('teapotBottleCheckbox');
    var selectMenu2 = document.getElementById('menu2');

    // ページ読み込み時にチェックボックスの状態を確認
    toggleSelectMenu2(checkbox.checked);

    // チェックボックスの状態変化を監視
    checkbox.addEventListener('change', function() {
        toggleSelectMenu2(this.checked);
    });

    // menu2の有効/無効を切り替える関数
    function toggleSelectMenu2(isChecked) {
        selectMenu2.disabled = !isChecked;
        if (isChecked) {
            selectMenu2.classList.remove('disabled');
        } else {
            selectMenu2.classList.add('disabled');
        }
    }
});

function toggleSelectMenu2(isChecked) {
    selectMenu2.disabled = !isChecked;
    if (isChecked) {
        selectMenu2.classList.remove('disabled');
    } else {
        selectMenu2.classList.add('disabled');
    }
}

document.getElementById('goButton').addEventListener('click', function() {
  var selectedMenu1 = document.getElementById('menu1').value;
  var selectedMenu2 = document.getElementById('menu2').value;
  var checkbox = document.getElementById('teapotBottleCheckbox').checked;

  if (checkbox) {
    // チェックボックスがオンの場合
    if (selectedMenu1 && selectedMenu2) {
        var combination = selectedMenu1 + '_' + selectedMenu2;
        var url = '';

        switch (combination) {
          case 'light_CL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44367593570539&selling_plan=8014201067&quantity=1';
              break;
          case 'light_C':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44367593603307&selling_plan=8014201067&quantity=1';
              break;
          case 'light_BL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44367593636075&selling_plan=8014201067&quantity=1';
              break;
          case 'light_B':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44367593668843&selling_plan=8014201067&quantity=1';
              break;
          case 'light_GD':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=46388464779499&selling_plan=8014201067&quantity=1';
              break;
          case 'light_GN':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=46388464812267&selling_plan=8014201067&quantity=1';
              break;
          case 'light_YL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=48041736437995&selling_plan=8014201067&quantity=1';
              break;
          case 'light_RL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=48041736503531&selling_plan=8014201067&quantity=1';
              break;
          case 'standard_CL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44367624863979&selling_plan=8014430443&quantity=1';
              break;
          case 'standard_C':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44384358498539&selling_plan=8014430443&quantity=1';
              break;
          case 'standard_BL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44367624896747&selling_plan=8014430443&quantity=1';
              break;
          case 'standard_B':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=44384358531307&selling_plan=8014430443&quantity=1';
              break;
          case 'standard_GD':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=46388459077867&selling_plan=8014430443&quantity=1';
              break;
          case 'standard_GN':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=46388459110635&selling_plan=8014430443&quantity=1';
              break;
          case 'standard_YL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=48041732636907&selling_plan=8014430443&quantity=1';
              break;
          case 'standard_RL':
              url = 'https://aardvarktea.jp/apps/subscription/buy?id=48041735913707&selling_plan=8014430443&quantity=1';
              break;
        case 'light_':
                url = 'https://developer.mozilla.org/en-US/docs/Web/CSS/vertical-align';
                break;
        case 'standard_':
                url = 'https://developer.mozilla.org/en-US/docs/Web/CSS/vertical-align';
                break;

          // 他の組み合わせに対するケースを追加
          // ...
          default:
              alert('エラーが発生しました。');
              return;
      }

        window.location.href = url;
        } else {
            alert('プラン・カラーを選択してください。');
        }
    } else {
        // チェックボックスがオフの場合
        var url = '';
        switch (selectedMenu1) {
            case 'light':
                url = 'https://aardvarktea.jp/apps/subscription/buy?id=46330741948651&selling_plan=10086351083&quantity=1';
                break;
            case 'standard':
                url = 'https://aardvarktea.jp/apps/subscription/buy?id=46330698399979&selling_plan=10086383851&quantity=1';
                break;
            default:
                alert('プランを選択してください。');
                return;
        }
        window.location.href = url;
    }
});